import { Injectable } from '@angular/core';
import { ListViewSettingModel } from '../../components/items-list/list-view-setting.model';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { ListViewTag } from '../../components/items-list/list-view-setting.model';
import { ObjectTypes } from '@fi-shared/types';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

@Injectable()
export class ListViewSettingsService {
    constructor(
        private fiBackend: FiBackendService,
        private userDataService: FiUserDataService,
    ) {}

    getSetting(objectType: ObjectTypes) {
        return new Promise<ListViewSettingModel>((resolve, reject) => {
            this.getSettings([objectType]).then((listViewSettings) => {
                resolve(listViewSettings[0]);
            }, reject);
        });
    }

    getSettings(
        objectTypes: ObjectTypes[],
        args?: {
            siteDesignId?: number;
        },
    ) {
        if (!args) {
            args = {};
        }
        if (!args.siteDesignId) {
            args.siteDesignId = this.userDataService.getActiveSiteDesignId();
        }

        const objectTypesParam = objectTypes.map((objectType) => `objectTypes=${objectType}`).join('&');
        let url = `Appearance/Appearance/GetListViewSettings?${objectTypesParam}&siteDesignId=${args.siteDesignId}`;
        return this.fiBackend.fetchObjects<ListViewSettingModel>(url, ListViewSettingModel);
    }

    saveSettings(settings: ListViewSettingModel[], siteDesignId: number) {
        settings.forEach((setting) => {
            setting.ListViewTags = setting.ListViewTags.map((listViewTag) =>
                new ListViewTag().InitWithObjectTag(listViewTag),
            );
        });

        return this.fiBackend.fetchDataPost(`Appearance/Appearance/SaveListViewSettings/${siteDesignId}`, settings);
    }
}
